document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('.add-to-cart-form');

  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(this);
      const cartDrawer = document.querySelector('cart-drawer');

      // 如果有购物车drawer，获取需要更新的sections
      if (cartDrawer) {
        const sections = cartDrawer.getSectionsToRender().map(section => section.id);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
      }

      // 提交加购请求
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(response => {
        // 成功添加到购物车
        showNotification('产品已添加到购物车');

        // 刷新购物车内容并打开drawer
        if (cartDrawer) {
          cartDrawer.setActiveElement(document.activeElement);
          cartDrawer.renderContents(response);
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        showNotification('添加失败，请重试', 'error');
      });
    });
  });
});

// 显示通知
function showNotification(message, type = 'success') {
  const notification = document.createElement('div');
  notification.className = `notification notification--${type}`;
  notification.textContent = message;
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${type === 'success' ? '#00ff00' : '#ff4444'};
    color: #000;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 9999;
    font-weight: 600;
    animation: slideIn 0.3s ease;
  `;

  document.body.appendChild(notification);

  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease';
    setTimeout(() => notification.remove(), 300);
  }, 2000);
}

// 添加动画样式
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);
